import { css  } from '@emotion/core'
import { mq, variables } from '../../cssInJs'

export default {
  top: css(mq({
    //height: [44, null, 80],
    height: [44, null, 56],
    background: variables.colorDarkBrown,
    position: 'fixed',
    width: '100%',
    zIndex: '999',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    transition: 'all 0.3s'
  })),
  topScrolled: css(mq({
    //height: [44, null, 56],
    //background: 'white'
  })),
  logo: css(mq({
  })),
  logoImg: css(mq({
    display: 'block',
    height: [120, null, 160],
    marginTop: ['3rem', null, '3rem'],
    transition:'all .2s'
  })),
  logoScrolled: css(mq({
    img : css(mq({
      height: [40, null, 52],
      marginTop:'0rem'
    }))
  })),
}